import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClinicCreate } from 'lib/api/firebase/apis/apis';

export function useCreateClinic() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: apiClinicCreate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organizations'] });
    }
  });
}
